export const SET_PAGE_SIZE = '@pageSize/SET_PAGE_SIZE';
export const GET_PAGE_SIZE = '@pageSize/GET_PAGE_SIZE';
